import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import './Loading.scss'

interface ILoadingOverlayProps {
    message?: string | React.ReactNode
}
export const LoadingOverlay: React.FC<ILoadingOverlayProps> = (props) => {

    return <div className="query-editor-loading-overlay-container">
        <Loading {...props} />
    </div>
}

export const Loading: React.FC<ILoadingOverlayProps> = (props) => {
    const { message } = props

    return <div className="query-editor-loading-container">
        {
            (!!message)
                ? <>{message} {(typeof message == 'string') ? <FontAwesomeIcon icon={['fas', 'spinner']} spin /> : null} </>
                : <>Loading...<FontAwesomeIcon icon={['fas', 'spinner']} spin /></>
        }
    </div>
}